import { Star } from 'lucide-react'
import { formatSpecValue } from './seoReportSpecFormat'

// ---------------------------------------------------------------------------
// Types
// ---------------------------------------------------------------------------

export interface SeoReportProductSpecsProps {
  specs: Array<{ label: string; value: string }>
  rating?: { score: number; count?: string | null } | null
  onSeeAll?: () => void
}

// ---------------------------------------------------------------------------
// Main component
// ---------------------------------------------------------------------------

export function SeoReportProductSpecs({
  specs,
  rating,
  onSeeAll,
}: SeoReportProductSpecsProps) {
  if (specs.length === 0) return null

  return (
    <div className='flex flex-col gap-4'>
      <div className='flex items-baseline justify-between'>
        <h3 className='text-base font-semibold leading-[30px] text-foreground md:text-xl'>
          Key specs
        </h3>
        <button
          type='button'
          onClick={onSeeAll}
          className='inline-flex cursor-pointer items-baseline gap-1 text-sm font-medium leading-6 text-info-700 hover:underline md:text-base'
        >
          see details &rarr;
        </button>
      </div>
      <table className='w-full border-collapse'>
        <tbody>
          {specs.map((spec, index) => {
            const display = formatSpecValue(spec.value)
            return (
              <tr
                key={`${spec.label}-${index}`}
                className='border-b border-accent'
              >
                <td className='w-1/2 text-pretty py-2 text-sm font-normal leading-5 text-foreground-muted'>
                  {spec.label}
                </td>
                <td
                  className='w-1/2 text-pretty py-2 text-right text-sm font-semibold leading-5 text-foreground-secondary'
                  title={display}
                >
                  {display}
                </td>
              </tr>
            )
          })}
          {rating && (
            <tr>
              <td className='w-1/2 py-2 text-sm font-normal leading-5 text-foreground-muted'>
                Avg user reviews
              </td>
              <td className='w-1/2 py-2 text-right text-sm font-semibold leading-5 text-foreground-secondary'>
                <span className='inline-flex items-center gap-1'>
                  <Star
                    className='size-3.5 text-amber-400'
                    fill='currentColor'
                    strokeWidth={0}
                  />
                  {rating.score.toFixed(1)}
                  {rating.count && (
                    <span className='font-normal text-foreground-muted'>
                      ({rating.count})
                    </span>
                  )}
                </span>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  )
}
